// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"08ada77b","703":"8a9ea408","787":"1dd2124d"}[chunkId] + ".chunk.js";
};